<template>
  <v-app>
    <v-main>
      <!-- Fondo atractivo con gradiente -->
      <div class="register-background d-flex align-center justify-center">
        <v-col cols="12" sm="8" md="5">
          <!-- Card de registro con sombras y bordes -->
          <v-card class="elevation-12 rounded-lg" max-width="650">
            <v-toolbar dark color="primary">
              <v-toolbar-title align="center">{{
                $t("registrarse")
              }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <form ref="form" @submit.prevent="registerHandler">
                <v-row>
                  <v-col cols="12" sm="6">
                    <!-- Campo para contraseña -->
                    <v-text-field
                      v-model="name"
                      name="name"
                      :label="$t('nombre')"
                      type="text"
                      :placeholder="$t('placeholder_nombre')"
                      required
                      outlined
                      dense
                      :rules="[validateFields]"
                      class="mb-2"
                    ></v-text-field>
                  </v-col>
                  <!-- Campo para contraseña -->
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="lastname"
                      name="lastname"
                      :label="$t('apellidos')"
                      type="text"
                      :placeholder="$t('placeholder_apellidos')"
                      required
                      outlined
                      dense
                      :rules="[validateFields]"
                      class="mb-1"
                    ></v-text-field>
                  </v-col>
                  <!-- Campo para nombre de usuario -->
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="username"
                      name="username"
                      :label="$t('nombreuser')"
                      type="text"
                      :placeholder="$t('placeholder_username')"
                      required
                      outlined
                      dense
                      :rules="[validateFields]"
                      class="mb-2"
                    ></v-text-field>
                  </v-col>
                  <!-- Campo para correo electrónico -->
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="email"
                      name="email"
                      :label="$t('correo')"
                      type="email"
                      :placeholder="$t('placeholder_email')"
                      required
                      outlined
                      dense
                      :rules="[validateFields]"
                      class="mb-2"
                    ></v-text-field>
                  </v-col>

                  <!-- Campo para contraseña -->
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="password"
                      name="password"
                      :label="$t('password')"
                      type="password"
                      :placeholder="$t('placeholder_password')"
                      required
                      outlined
                      dense
                      :rules="[validatePassword]"
                      class="mb-2"
                    ></v-text-field>
                  </v-col>

                  <!-- Campo para confirmar la contraseña -->
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="confirmPassword"
                      name="confirmPassword"
                      :label="$t('confirmPass')"
                      type="password"
                      :placeholder="$t('placeholder_confirm_password')"
                      required
                      outlined
                      dense
                      :rules="[passwordMatchRule]"
                      class="mb-2"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Divider para separar secciones -->
                <v-divider class="my-4"></v-divider>

                <!-- Botón de registro -->
                <v-btn
                  type="submit"
                  class="mx-auto d-block mt-4 mb-4"
                  color="primary"
                  elevation="5"
                  :ripple="true"
                  :disabled="!formIsValid"
                >
                  {{ $t("crear") }}
                </v-btn>
              </form>
              <p>
                <strong>{{ $t("nota") }}</strong>
              </p>
              <!-- Validaciones visuales de la contraseña -->
              <v-list dense class="mb-4 pa-0">
                <v-list-item
                  class="pa-0"
                  v-for="(rule, index) in passwordRules"
                  :key="index"
                >
                  <v-icon color="success" v-if="rule.valid"
                    >mdi-check-circle</v-icon
                  >
                  <v-icon color="error" v-else>mdi-close-circle</v-icon>
                  <span class="ml-2">{{ rule.message }}</span>
                </v-list-item>
              </v-list>

              <!-- Enlace para redirigir a login -->
              <p class="text-center">
                {{ $t("haveaccount") }}
                <router-link
                  to="/index"
                  class="font-weight-bold text-primary"
                  >{{ $t("startSession") }}</router-link
                >
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </div>
      <v-snackbar
        v-model="showSnackbar"
        :color="snackbarColor"
        timeout="4000"
        location="top right"
        position="fixed"
      >
        <v-icon left class="mr-2">mdi-close-circle </v-icon>
        {{ snackbarMessage }}
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import api from "@/api/axios/axios.js";
export default {
  name: "registerPage",

  data() {
    return {
      name: "",
      lastname: "",
      username: "",
      email: "",
      password: "",
      confirmPassword: "",
      showSnackbar: false,
      snackbarColor: "",
      snackbarMessage: "",
      languages: [
        { label: "🇲🇽 Español", value: "es" },
        { label: "🇺🇸 English", value: "en" },
      ],
    };
  },
  computed: {
    isPasswordValid() {
      return this.passwordRules.every((rule) => rule.valid);
    },
    formIsValid() {
      return (
        this.name &&
        this.lastname &&
        this.username &&
        this.email &&
        this.password &&
        this.confirmPassword === this.password &&
        this.isPasswordValid
      );
    },
    passwordRules() {
      return [
        {
          message: this.$t("rulepass1"),
          valid: this.password.length >= 8,
        },
        {
          message: this.$t("rulepass2"),
          valid: /[A-Z]/.test(this.password),
        },
        {
          message: this.$t("rulepass3"),
          valid: /\d/.test(this.password),
        },
        {
          message: this.$t("rulepass4"),
          valid: /[!@#$%^&*(),.?":{}|<>]/.test(this.password),
        },
      ];
    },
    validateFields() {
      return (value) => {
        if (!value) {
          return this.$t("obligatorio");
        }
        return true;
      };
    },
    passwordMatchRule() {
      return (value) => {
        if (value !== this.password) {
          return this.$t("coinc");
        }
        return true;
      };
    },
    validatePassword() {
      //   const expReg =
      //     /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/;
      return (value) => {
        if (!value) {
          return this.$t("obligatorio1");
        }
        // if (!expReg.test(value)) {

        //   return "La contraseña debe tener al menos 9 caracteres, una mayúscula, un número y un carácter especial";
        // }
        return true;
      };
    },
  },
  methods: {
    async registerHandler() {
      // Datos que se enviarán al backend
      const data = {
        username: this.username,
        email: this.email,
        password: this.password,
        first_name: this.name,
        last_name: this.lastname, // Aquí puedes agregar el primer nombre si lo deseas
      };

      try {
        // Realiza la solicitud POST a la API de Django
        await api.post("/login/register/", data);
        // console.log(response)
        // alert('Usuario creado con éxito');
        this.$router.push({
          path: "index",
          query: { mensaje: this.$t("user_created_success") },
        }); // Redirigir a la página de login si usas Vue Router
      } catch (error) {
        // Si hubo un error, mostrar el mensaje
        this.showSnackbar = true;
        this.snackbarColor = "error";

        //console.log(error.response.data.username)
        if (error.response.data.email && error.response.data.username) {
          this.snackbarMessage = this.$t("user_email_exists");
        } else {
          if (error.response.data.email) {
            this.snackbarMessage = error.response.data.email[0];
          } else if (error.response.data.username) {
            this.snackbarMessage = this.$t("username_exists");
          } else {
            this.snackbarMessage = this.$t("register_error");
          }
        }
        //this.snackbarMessage=error.response.data.email || error.response.data.username || "Error al crear la cuenta"
        // console.error('Error en el registro:', error.response.data);
        // alert('Hubo un error al crear la cuenta. Intenta de nuevo.');
      }
    },
  },
};
</script>

<style scoped>
/* Fondo de página con gradiente */
.register-background {
  background: linear-gradient(to right, #154390, #6c88b6);
  min-height: 100vh;
}

/* Opcional: Agregar sombra y bordes redondeados a la tarjeta */
.v-card {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.router-link {
  text-decoration: none;
  font-size: 14px;
}
</style>
